import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto mb-2 rounded-full bg-primary-300" }
const _hoisted_2 = { class: "text-sm leading-5 text-center text-gray-500" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { action: "#" }
const _hoisted_5 = { class: "w-full mx-auto mb-6" }
const _hoisted_6 = { class: "flex justify-center space-x-3" }
const _hoisted_7 = { class: "relative flex justify-center" }
const _hoisted_8 = { class: "relative flex justify-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1)
const _hoisted_10 = { class: "relative flex justify-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1)
const _hoisted_12 = { class: "relative flex justify-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1)
const _hoisted_14 = { class: "relative flex justify-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1)
const _hoisted_16 = { class: "relative flex justify-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1)
const _hoisted_18 = { class: "flex justify-between space-x-3 mt-9" }

import { ref, onMounted, computed } from "vue";

import {
    IonInput
} from '@ionic/vue';

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import SixInput from '@/components/forms/SixInput.vue';
import PinCodeProcessor from '@/helpers/hashPin';
import lockCircleIcon from "@/components/icons/lockCircleIcon.vue";
import { useRecordStatusChecker } from "@/store/recordStatusChecker";


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionLockModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
        default: 'Logout'
    },
    customClass: {
        type: String,
        default: 'py-6 px-6 w-[480px]'
    },
    whiteBg: {
        type: Boolean,
        default: false
    },
    validate: {
        type: Boolean,
        default: true
    },
    pinCode: {
        type: String,
        default: '',
    },
    hasPinCode: {
        type: Boolean,
        default: false
    },
    isNetworkAvailable: {
        type: Boolean,
        default: true,
    }
},
  emits: ['confirm'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props

const otpNum = [
    { num1: ref(null) },
    { num2: ref(null) },
    { num3: ref(null) },
    { num4: ref(null) },
    { num5: ref(null) },
    { num6: ref(null) }
];

const status = ref<boolean>(false)
const error = ref<boolean>(false)
const recordStatusChecker = useRecordStatusChecker();

const moveFocus = (event:any , nextElement:any, previousElement:any) => {
    if (event.keyCode == 8 && previousElement) {
        previousElement.setFocus();
    } else if (event.target.value && event.keyCode >= 48 && event.keyCode <= 57) {
        if (nextElement) {
            nextElement.setFocus();
        }
    }
};

let otp = '';
const formatOTP = ():string => {
    // otpNum.forEach((value:any, key:number) => {
    //     otp += otpNum[`num${key + 1}`];
    // });
    return `${(otpNum.num1||"")}${(otpNum.num2||"")}${(otpNum.num3||"")}${(otpNum.num4||"")}${(otpNum.num5||"")}${(otpNum.num6||"")}`;
    // return otp;
}

const setPinCode = (): void => {  
    props.pinCode.split('').forEach((value: any, key: number) => {
        otpNum[`num${key + 1}`] = value;
    }); 
}

const clearPin  = (): void => { 
    otp= "";
    otpNum.num1 = null;    
    otpNum.num2 = null;    
    otpNum.num3 = null;    
    otpNum.num4 = null;    
    otpNum.num5 = null;  
    otpNum.num6 = null;  
}

const confirm = (): void => {
    if (props.validate) {
        status.value = PinCodeProcessor.validate(formatOTP());
        console.log(status.value);
        error.value = !status.value;
        if (status.value) {
            resetModals();
            emit('confirm',  status.value);
        }
    }

    emit('confirm', false); 

    //clear Pin when modal appear
    if(status.value){
        clearPin();
    }  

}

const resetModals = () => {
    const modals = document.querySelectorAll('#headlessui-portal-root > div');
    // Remove all child divs except the last one
    const arrayModals = Array.from(modals);
    for (const index in arrayModals) {
        document.getElementById('app')?.removeAttribute('aria-hidden');
        document.getElementById('app')?.removeAttribute('inert');
        arrayModals[index].remove();
    }
}

onMounted(() => {
    if (props.hasPinCode) {  
        setPinCode()
    }

    if (!props.isNetworkAvailable) {
        if (!recordStatusChecker.isDownloadingResources) {
            setTimeout(() => {
                document.querySelector('form #otp1')?.setFocus();
                const modals = document.querySelectorAll('#headlessui-portal-root > div');
                // Remove all child divs except the last one
                const arrayModals = Array.from(modals);
                for (const index in arrayModals) {
                    if (parseInt(index) > 0) {
                        document.getElementById('app')?.removeAttribute('aria-hidden');
                        document.getElementById('app')?.removeAttribute('inert');
                        arrayModals[index].remove();
                    }
                }
            }, 1000);
        }
    }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show,
    whiteBg: __props.whiteBg
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(lockCircleIcon, { class: "object-contain w-6 h-6" })
      ]),
      _createVNode(_unref(DialogTitle), {
        as: "p",
        class: "text-xl font-bold text-center text-neutral-900 focus-visible:outline-none",
        tabindex: "0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (__props.content)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.content), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content"),
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(IonInput), {
                  id: "otp1",
                  type: "password",
                  modelValue: otpNum.num1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otpNum.num1) = $event)),
                  ref: "otp1",
                  onKeyup: _cache[1] || (_cache[1] = ($event: any) => (moveFocus($event, _ctx.$refs.otp2.$el, ''))),
                  placeholder: "○",
                  class: "otp pin-input",
                  maxlength: "1",
                  inputmode: "numeric",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(IonInput), {
                  type: "password",
                  modelValue: otpNum.num2,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((otpNum.num2) = $event)),
                  ref: "otp2",
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (moveFocus($event, _ctx.$refs.otp3.$el, _ctx.$refs.otp1.$el))),
                  placeholder: "○",
                  class: "otp pin-input",
                  maxlength: "1",
                  inputmode: "numeric",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(IonInput), {
                  type: "password",
                  modelValue: otpNum.num3,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((otpNum.num3) = $event)),
                  ref: "otp3",
                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => (moveFocus($event, _ctx.$refs.otp4.$el, _ctx.$refs.otp2.$el))),
                  placeholder: "○",
                  class: "otp pin-input",
                  maxlength: "1",
                  inputmode: "numeric",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(IonInput), {
                  type: "password",
                  modelValue: otpNum.num4,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((otpNum.num4) = $event)),
                  ref: "otp4",
                  onKeyup: _cache[7] || (_cache[7] = ($event: any) => (moveFocus($event, _ctx.$refs.otp5.$el, _ctx.$refs.otp3.$el))),
                  placeholder: "○",
                  class: "otp pin-input",
                  maxlength: "1",
                  inputmode: "numeric",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(IonInput), {
                  type: "password",
                  modelValue: otpNum.num5,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((otpNum.num5) = $event)),
                  ref: "otp5",
                  onKeyup: _cache[9] || (_cache[9] = ($event: any) => (moveFocus($event, _ctx.$refs.otp6.$el, _ctx.$refs.otp4.$el))),
                  placeholder: "○",
                  class: "otp pin-input",
                  maxlength: "1",
                  inputmode: "numeric",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(IonInput), {
                  type: "password",
                  modelValue: otpNum.num6,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((otpNum.num6) = $event)),
                  ref: "otp6",
                  onKeyup: _cache[11] || (_cache[11] = ($event: any) => (moveFocus($event, '', _ctx.$refs.otp5.$el))),
                  placeholder: "○",
                  class: "otp pin-input",
                  maxlength: "1",
                  inputmode: "numeric",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _hoisted_17
              ])
            ])
          ])
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: _normalizeClass(["text-[10px] mt-1", error.value ? 'text-red-600' : 'text-gray-800']),
              id: "email-error"
            }, " Pin Code dose not match ", 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (__props.isNetworkAvailable)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              size: "large",
              btnWidth: "quinary rounded-lg w-full",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('cancel')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.cancelText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(ButtonComponent, {
          size: "large",
          btnWidth: "primary rounded-lg w-full",
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.actionText), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }, 8, ["customClass", "show", "whiteBg"]))
}
}

})